import { CONTACT_MESSAGE_LIST } from "../action/type";

const initialState = {
    list: [{}],
};
const contact = (state = initialState, action) => {
    switch (action.type) {
        case CONTACT_MESSAGE_LIST:
            return { ...state, list: action.payload };
        default:
            return state;
    }
};

export default contact;
